declare function onKeyUpEscape(event: Event): void;
class FacetFiltersForm extends HTMLElement {
  static filterData: { html: string; url: string }[] = [];
  static searchParamsInitial: string = window.location.search.slice(1);
  static searchParamsPrev: string = window.location.search.slice(1);

  debouncedOnSubmit!: (event: Event) => void;
  constructor() {
    super();
    if (!this.querySelector("form")) return;
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector("form")?.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event: PopStateEvent) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams: string, event: Event | null, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById("ProductCountDesktop");
    document.getElementById("ProductGridContainer")!.querySelector(".collection")!.classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element: { html: string; url: string }) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url: string, event: Event | null) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl: (element: { html: string; url: string }) => boolean, event: Event | null) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl)!.html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html: string) {
    document.getElementById("ProductGridContainer")!.innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("ProductGridContainer")!.innerHTML;
  }

  static renderProductCount(html: string) {
    const count = new DOMParser().parseFromString(html, "text/html").getElementById("ProductCount")!.innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container!.innerHTML = count;
    container!.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }

  static renderFilters(html: string, event: Event | null) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");

    const facetDetailsElements = parsedHTML.querySelectorAll<HTMLElement>("#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter");
    const matchesIndex = (element: HTMLElement) => {
      const jsFilter = event ? ((event.target as Element)!.closest(".js-filter") as HTMLElement | null) : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element as HTMLElement));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector<HTMLElement>(`.js-filter[data-index="${element.dataset.index}"]`)!.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, (event?.target as HTMLElement).closest(".js-filter") as HTMLElement | null);
  }

  static renderActiveFacets(html: Document) {
    const activeFacetElementSelectors = [".active-facets-mobile", ".active-facets-desktop"];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector<HTMLElement>(selector)!.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html: Document) {
    const mobileElementSelectors = [".mobile-facets__open", ".mobile-facets__count", ".sorting"];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector<HTMLElement>(selector)!.innerHTML = html.querySelector(selector)!.innerHTML;
    });

    //document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source: HTMLElement, target: HTMLElement | null) {
    const targetElement = target?.querySelector(".facets__selected");
    const sourceElement = source.querySelector(".facets__selected");

    if (sourceElement && targetElement) {
      (target as HTMLElement).querySelector(".facets__selected")!.outerHTML = source.querySelector(".facets__selected")!.outerHTML;
    }
  }

  static updateURLHash(searchParams: string) {
    history.pushState({ searchParams }, "", `${window.location.pathname}${searchParams && "?".concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid")!.dataset.id,
      },
    ];
  }

  onSubmitHandler(event: Event) {
    event.preventDefault();
    const target = event.target as HTMLInputElement;
    if (target.value.includes("AirPods")) {
      document.cookie = `favAirPods=${target.value}; path=/; max-age=${60 * 60 * 24 * 14};`;
    } else if (target.value.includes("Galaxy") || target.value.includes("Google") || target.value.includes("iPhone") || target.value.includes("LG G7")) {
      document.cookie = `favPhone=${target.value}; path=/; max-age=${60 * 60 * 24 * 14};`;
    }
    let toggleFilter = document.querySelector<HTMLElement>("[data-toggle-filters]");
    if (toggleFilter) {
      if (document.querySelector('[data-first-load="true"]')) {
        document.querySelector('[data-first-load="true"]')!.removeAttribute("data-first-load");
      } else {
        toggleFilter.click();
      }
    }
    const formData = new FormData((event.target as HTMLFormElement).closest("form") ?? undefined);
    const searchParams = new URLSearchParams(formData as any).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event: MouseEvent) {
    event.preventDefault();
    const target = event.currentTarget as HTMLAnchorElement;
    FacetFiltersForm.toggleActiveFacets();
    const url = target.href.indexOf("?") == -1 ? "" : target.href.slice(target.href.indexOf("?") + 1);
    FacetFiltersForm.renderPage(url, null);
  }
}

customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => element.addEventListener("change", this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event: Event) {
    const target = event.currentTarget as HTMLInputElement;
    this.adjustToValidValues(target);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("min", "0");
    if (maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max") ?? "");
  }

  adjustToValidValues(input: HTMLInputElement) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("min"));
    const max = Number(input.getAttribute("max"));

    if (value < min) input.value = min.toString();
    if (value > max) input.value = max.toString();
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    let alink = this.querySelector("a");
    if (alink) {
      alink.addEventListener("click", (event) => {
        event.preventDefault();
        const form = (this.closest("facet-filters-form") || document.querySelector("facet-filters-form")) as FacetFiltersForm | null;
        form?.onActiveFilterClick(event);
      });
    }
  }
}

customElements.define("facet-remove", FacetRemove);

let windowsYOffset = window.scrollY;
let asideTogglers = document.querySelectorAll("[data-toggle-filters]");
asideTogglers.forEach((element) => {
  element.addEventListener("click", (e) => {
    e.preventDefault();
    element.classList.toggle("--active");
    document.querySelector(".facets-container")!.classList.toggle("--open");

    if (element.classList.contains("--active")) {
      windowsYOffset = window.scrollY;
      window.addEventListener("scroll", closeFiltersToggleOnScroll);
    } else {
      window.removeEventListener("scroll", closeFiltersToggleOnScroll);
    }
  });
});

let closeFiltersToggleOnScroll = (event: Event) => {
  let scrollYOffset = window.scrollY;
  let oldScroll = windowsYOffset + 500;
  let minusOldScroll = windowsYOffset - 500;
  if (scrollYOffset > oldScroll || scrollYOffset < minusOldScroll) {
    document.querySelector<HTMLElement>("[data-toggle-filters]")!.click();
  }
};

let deviceList = document.querySelectorAll('[for^="Filter-Device-"], [for^="Filter-Modèle-"]');
if (deviceList.length > 0) {
  let currentFavPhone = getCookie("favPhone");
  if (!currentFavPhone) {
    currentFavPhone = "iPhone 17";
  }

  // More efficient: find the specific matching device directly
  const matchingDevice = Array.from(deviceList).find((device) => {
    const input = device.querySelector("input");
    return input && input.value === currentFavPhone && !input.checked;
  });

  if (matchingDevice) {
    matchingDevice.querySelector("input")!.click();
  }
}
